import { Space } from '../../types/listing/space';
import defaultListing from '../../api/defaults/listing';
import { Specifications } from './../../types/listing/specifications';
import { Listing } from '../../types/listing/listing';
import { roundOff } from '../math';

const fillInvalidValues = (specifications: Specifications): Specifications => {
    if(!specifications) {
        specifications = defaultListing.specifications;
    }
    if (specifications) {
        if (!specifications.totalSpace || isNaN(specifications.totalSpace)) {
            specifications.totalSpace = 0;
        } else {
            specifications.totalSpace = roundOff(Number(specifications.totalSpace));
        }
        
        if (!specifications.salePrice || isNaN(specifications.salePrice)) {
            specifications.salePrice = 0;
        } else {
            specifications.salePrice = roundOff(Number(specifications.salePrice));
        }

        if (!specifications.minPrice || isNaN(specifications.minPrice)) {
            specifications.minPrice = 0;
        } else {
            specifications.minPrice = roundOff(Number(specifications.minPrice));
        }

        if (!specifications.maxPrice || isNaN(specifications.maxPrice)) {
            specifications.maxPrice = 0;
        } else {
            specifications.maxPrice = roundOff(Number(specifications.maxPrice));
        }
    }
    return specifications;
}

export const preProcessMIQListing = (listing: Listing): Listing => {
    if (listing && Array.isArray(listing.spaces) && listing.spaces.length > 0) { 
        let totalSpaces = 0;
        let salePrice = 0;
        let minPrice = 0;
        let maxPrice = 0;
        const nSpaces = listing.spaces.length;
        for(let i = 0; i < nSpaces; i++) {
            listing.spaces[i].specifications = fillInvalidValues(listing.spaces[i].specifications);
            if(listing.id > 0 && listing.spaces[i].id === 0) {
                continue;
            }
            totalSpaces += listing.spaces[i].specifications.totalSpace;
            salePrice += listing.spaces[i].specifications.salePrice;
            minPrice += listing.spaces[i].specifications.minPrice;
            maxPrice += listing.spaces[i].specifications.maxPrice;
        }
        listing.specifications = fillInvalidValues(listing.specifications);
        listing.specifications.totalSpace = roundOff(totalSpaces);
        listing.specifications.salePrice = roundOff(salePrice);
        listing.specifications.minPrice = roundOff(minPrice);
        listing.specifications.maxPrice = roundOff(maxPrice);
    } else {
        // safe gaurding against null spaces.
        listing.spaces = [];
    }
    return listing;
}